import { gsap } from "gsap";
import commentJSON from "./commentList.json";
import { isSP } from "../functions/isSP.es6";

export default class FooterFamily {
    constructor() {
        this.id = document.querySelector(".l-footer__family").getAttribute("data-id") || "dwu";
        this.commentArray = [];
        this.animationShowed = false;
        this.loopAnim = null;
        this.init();
    }

    init() {
        this.setComments();
        this.watchScroll();
        this.mouseEvent();
    }

    mouseEvent() {
        const ph = document.querySelector(".l-footer__family__ph__linkarea");
        const cmtwrap = document.querySelector(".l-footer__family__wrapper");

        ph.addEventListener("mouseenter", () => {
            if (!isSP()) {
                cmtwrap.setAttribute("data-hover", "1");
            }
        });
        ph.addEventListener("mouseleave", () => {
            if (!isSP()) {
                cmtwrap.removeAttribute("data-hover");
            }
        });
    }

    watchScroll() {
        // 監視する対象（data-orderの値順にtargetObjectsに入れています）
        const targetObjects = [...document.querySelectorAll(".l-footer__inner")];

        // IntersectionObserverの設定
        const options = {
            threshold: 0,
        };

        // コールバックの受け取り
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //console.log(`Footer : 交差開始`);
                    this.showAnimation();
                } else {
                    //console.log(`Footer : 交差終了`);
                    this.killLoopAnim();
                }
            });
        };

        // IntersectionObserverオブジェクトを作る
        const observerObject = new IntersectionObserver(callback, options);

        // 監視対象の監視を開始する
        targetObjects.forEach((object) => {
            observerObject.observe(object);
        });
    }

    killLoopAnim() {
        if (this.loopAnim) {
            this.loopAnim.kill();
        }
    }

    showAnimation() {
        //ループコメントアニメも交差しているときだけでいいかも
        if (!this.animationShowed) {
            for (let i = 0; i < this.commentArray.length - 1; i++) {
                gsap.fromTo(this.commentArray[i], { opacity: 0, y: "50%" }, { opacity: 1, y: "0", duration: 0.5, ease: "Power3.inOut", delay: i * 0.05 });
            }
            document.querySelector(".l-footer__family").setAttribute("data-active", "1");
            //gsap.fromTo(".l-footer__family__ph", { opacity: 0, y: "20%" }, { opacity: 1, y: "0", duration: 0.8, ease: "circ.inOut", delay: 0 });
        }

        this.animationShowed = true;
        this.setCommentWrapperAnim();
    }

    getRandRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    setCommentWrapperAnim() {
        const wrapper = document.querySelector(".js-footer_family_commentwrap");
        const duration = window.innerWidth <= 835 ? 20 * (window.innerWidth / 390) : 40 * (window.innerWidth / 1920);
        this.loopAnim = gsap.to(wrapper, { x: "-50%", duration: duration, ease: "linear", repeat: -1 });
    }

    getAmount() {
        const baseAmount = window.innerWidth <= 835 ? 10 : 30;
        let amount = 0;

        if (window.innerWidth <= 835) {
            amount = Math.floor(baseAmount * (window.innerWidth / 390)) * 2;
        } else {
            amount = Math.floor(baseAmount * (window.innerWidth / 1920)) * 2;
        }
        return amount;
    }

    setComments() {
        const wrapper = document.querySelector(".js-footer_family_commentwrap");
        const commentList = commentJSON[this.id];
        const maxTryCount = 10;
        const amount = this.getAmount();

        const isInRange = (target, count) => {
            let flag = false;

            if (count > maxTryCount) {
                return false;
            }

            for (let i = 0; i < this.commentArray.length - 1; i++) {
                const checkOne = this.commentArray[i];
                const y1 = target.offsetTop;
                const y2 = target.offsetTop + target.offsetHeight;
                const x1 = target.offsetLeft;
                const x2 = target.offsetLeft + target.offsetWidth;

                const ya = checkOne.offsetTop;
                const yb = checkOne.offsetTop + checkOne.offsetHeight;
                const xa = checkOne.offsetLeft;
                const xb = checkOne.offsetLeft + checkOne.offsetWidth;

                const rangeY = (y1 >= ya && y1 <= yb) || (y2 >= ya && y2 <= yb);
                const rangeX = (x1 >= xa && x1 <= xb) || (x2 >= xa && x2 <= xb);

                flag = rangeY && rangeX; //交差しているかのチェック
                if (flag) break;
            }

            return flag;
        };

        const setPosition = (dom, count) => {
            dom.style.top = this.getRandRange(0, 85) + "%";
            dom.style.left = Math.random() * 100 + "%";

            if (isInRange(dom, count)) {
                //console.log("交差あり");
                count++;
                setPosition(dom, count);
            } else {
                //console.log("交差なし");
            }
        };

        for (let i = 0; i < amount; i++) {
            let count = 0;
            const dom = document.createElement("div");
            const dom_obj = document.createElement("span");
            dom.classList.add("l-footer__family__comment__item");
            dom_obj.classList.add("l-footer__family__comment__item__obj");
            dom_obj.textContent = commentList[Math.floor(Math.random() * commentList.length)];

            dom.appendChild(dom_obj);
            wrapper.appendChild(dom);
            setPosition(dom, count); //再帰
            this.commentArray.push(dom);
        }
    }
}
